import React from "react";

export const LibertateContext = React.createContext();
